/**
 * Human-readable byte size.
 *
 * Relocated from pages/IncidentManagement/components/NewIncidentDialog/fileUtils
 * when Incident Management moved to the investigator repo. Station Admin's
 * Internal Affairs cards were the other consumer, so this outlived the page.
 */
export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
